<template>
  <div class="postSetting">
    <el-container>
      <el-header>
        <el-row>
          <el-form ref="postform" :model="postform" label-width="60px" :inline="true">
            <el-col :span="6">
              <el-form-item label="岗位名称" prop="name">
                <el-input v-model="postform.name" placeholder="-请输入-"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属组织">
                <el-select v-model="postform.orgId">
                  <el-option v-for="sys in GovList" :key="sys.id" :label="sys.name" :value="sys.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所属角色">
                <el-select v-model="postform.roleId">
                  <el-option
                    :label="role.name"
                    :value="role.id"
                    v-for="role in roleList"
                    :key="role.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
          <el-col :span="6" style="text-align:right;">
            <div class="handlePanel">
              <el-button type="primary" @click="selectBtnPressed()">查询</el-button>
              <el-button type="info" @click="resetBtnPressed()">重置</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align:right;">
            <div class="operatePanel">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="addBtnPressed()"
                v-if="btnAuthorize.addBtn.btnEnable"
              >新增</el-button>
              <el-button
                type="primary"
                icon="el-icon-edit"
                @click="updBtnPressed()"
                v-if="btnAuthorize.modifyBtn.btnEnable"
              >修改</el-button>
              <el-button
                type="primary"
                icon="el-icon-delete"
                @click="delBtnPressed()"
                v-if="btnAuthorize.delBtn.btnEnable"
              >删除</el-button>
            </div>
          </el-col>
        </el-row>
        <!-- <div style="clear:both;"></div> -->
      </el-header>
      <el-main ref="main">
        <el-table
          :data="postionList"
          highlight-current-row
          height="100%"
          size="mini"
          @current-change="handleSelectionChange"
          border
        >
          <el-table-column prop="name" label="岗位名称" :show-overflow-tooltip="true"></el-table-column>          
          <el-table-column prop="orgName" label="所属组织" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="roleName" label="角色名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="isResponse" label="是否负责人" :show-overflow-tooltip="true">
            <template slot-scope="props">{{props.row.isResponse==1?'是':'否'}}</template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="status" label="状态" :show-overflow-tooltip="true">
            <template slot-scope="props">{{props.row.status==1?'启用':'停用'}}</template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="postform.pageIndex"
          :page-sizes="[10, 20, 30, 40,50]"
          :page-size="postform.pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>
    <!-- 新增/修改弹窗 -->
    <el-dialog
      class="dialog816"
      :title="isAdd?'新增岗位':'修改岗位'"
      :visible.sync="isAddDialogShow"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="120px" :rules="addRules" ref="addForm">
        <el-row>
          <el-col :span="20">
            <el-form-item label="岗位名称" prop="name" label-position="right">
              <el-input v-model="addForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="所属组织" prop="orgId">
              <el-select v-model="addForm.orgId">
                <el-option
                  :label="dept.name"
                  :value="dept.id"
                  v-for="dept in GovList"
                  :key="dept.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="所属角色" prop="roleId">
              <el-select v-model="addForm.roleId">
                <el-option
                  :label="role.name"
                  :value="role.id"
                  v-for="role in roleList"
                  :key="role.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="20">
            <el-form-item label="是否负责人">
              <el-select v-model="addForm.isResponse">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="排序" prop="sort">
              <el-input v-model="addForm.sort"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="是否启用">
              <el-select v-model="addForm.status" disabled>
                <el-option label="启用" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="isAddDialogShow=false">取 消</el-button>
        <el-button type="primary" @click="saveBtnPressed()">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  manangerStationService,
  stationDetailsService,
  insertStationService,
  modifyStationService,
  deleteStationService,
  getEditRolesByUserCodeService, //获取角色列表
  getGovService //组织列表
} from "../../services/sysSettingService";
export default {
  name: "postSetting",
  data() {
    return {
      total: 0, //门禁总数
      GovList:[],  //组织列表
      postionList: [], //岗位设置列表
      deptList: [], //可选组织列表
      roleList: [], //角色列表
      isAddDialogShow: false, //新增岗位弹窗显示开关
      isAdd: true, //新增/修改岗位标识
      postSelected: null, //选中的岗位
      postform: {
        name: "",
        // roleId: "", //所属角色
        // deptId: "", //所属部门
        pageIndex: 1,
        pageSize: 10
      },
      addForm: {
        name: "",
        roleId: "", //所属角色
        orgId:"", //所属组织
        sort: 0,
        status:  "1",
        isResponse:"0"   //是否负责人，1 是 0 否
      },
      addRules: {
        name: [
          { required: true, message: "请输入岗位名称", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "输入内容长度必须介于1到30之间",
            trigger: "blur"
          }
        ],
        sort: [
          // { min: 1, max: 5, message: "输入内容长度必须介于1到5之间" },
          {
            pattern: /(^[0-9]\d*$)/,
            message: "输入内容必须为大于等于0的正整数",
            trigger: "blur"
          }
        ],
        roleId: [{ required: true, message: "请选择角色", trigger: "change" }],
        orgId: [{ required: true, message: "请选择组织", trigger: "change" }]
      },
      //按钮权限
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false }
      }
    };
  },
  props: {
    menuCode: {
      type: String
    }
  },
  methods: {
    //激活时调用
    onActive(menuCode) {
      if (this.$refs.postform) {
        this.$refs.postform.resetFields();
        this.postform.pageIndex = 1;
        this.postform.pageSize = 10;
      }
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.getUserOneLevelDept();
      this.getUserOneLevelRole();
      this.manangerStation();
    },
    /* 获取岗位列表 */
    manangerStation() {
      // this.postform.userCode = sessionStorage.getItem("userCode");
      manangerStationService(this.postform).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.total = res.total;
            this.postionList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 获取岗位详情 */
    stationDetails(postCode) {
      let reqParam = {
        postCode: postCode
      };
      stationDetailsService(reqParam).then(
        res => {
          console.log(res);
          if (res.resultCode == 0) {
            this.addForm = res.data;
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    insertStation() {
      // this.addForm.userCode = sessionStorage.getItem("userCode");
      insertStationService(this.addForm).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("新增成功", "提示");
            this.isAddDialogShow = false;
            this.manangerStation();
          } else {
            this.$message.error(res.msg);
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 修改岗位信息 */
    modifyStation() {
      // this.addForm.userCode = sessionStorage.getItem("userCode");
      modifyStationService(this.addForm).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("修改成功", "提示");
            this.isAddDialogShow = false;
            this.manangerStation();
          } else {
            this.$message.error(res.msg);
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 分页改变事件 */
    handleCurrentChange(page) {
      console.log(page);
      this.postform.pageIndex = page;
      this.manangerStation();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.postform.pageSize = rows;
      this.postform.pageIndex = 1;
      this.manangerStation();
    },

    /* 查询按钮回调 */
    selectBtnPressed() {
      this.manangerStation();
    },
    /* 重置按钮回调 */
    resetBtnPressed() {
      this.$refs.postform.resetFields();
      this.postform.orgId="";
      this.postform.roleId="";
    },
    /* 新增按钮回调 */
    addBtnPressed() {
      this.isAdd = true;
      this.isAddDialogShow = true;
      if (this.addForm != null) {
        this.addForm.name = "";
        this.addForm.orgId = "";
        this.addForm.roleId = "";
        this.addForm.sort = 0;
        this.addForm.status = "1";
        this.addForm.isResponse="0";
      }
    },
    /* 修改按钮回调 */
    updBtnPressed() {
      if (this.postSelected == null) {
        this.$alert("请选择一条要修改的记录！", "提示");
      } else {
        this.isAdd = false;
        this.isAddDialogShow = true;
        this.addForm.name = this.postSelected.name;
        this.addForm.orgId = this.postSelected.orgId;
        this.addForm.sort = this.postSelected.sort;
        this.addForm.id = this.postSelected.id;
        this.addForm.status = this.postSelected.status.toString();
        this.addForm.isResponse = this.postSelected.isResponse.toString();
        this.addForm.roleId = this.postSelected.roleId;
        // this.stationDetails(this.addForm.postCode);
      }
    },
    /* 删除按钮回调 */
    delBtnPressed() {
      if (this.postSelected == null) {
        this.$alert("请选择一条要修改的记录！", "提示");
      } else {
        this.$confirm("确定删除岗位?", "提示").then(() => {
          let params = {
            jobId: this.postSelected.id
          };
          deleteStationService(params).then(
            res => {
              console.log(res);
              if (res.code == 10000000) {
                this.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.manangerStation();
              } else {
                this.$alert(res.msg, "提示");
              }
            },
            err => {
              this.$alert(err, "提示", {
                confirmButtonText: "确定"
              });
            }
          );
        });
      }
    },
    /* 弹窗保存按钮回到 */
    saveBtnPressed() {
      this.$refs.addForm.validate(res => {
        if (res) {
          if (this.isAdd) {
            this.insertStation();
          } else {
            this.modifyStation();
          }
        }
      });
    },

    /* 列代表单选回调 */
    handleSelectionChange(post) {
      this.postSelected = post;
      if (post != null) {
        this.$nextTick(() => {
          this.addForm = Object.assign({}, post);
        });
      }
    },
    /* 获取新增角色时可选组织 */
    getUserOneLevelDept() {
      let reqParam = {
        pageIndex: 1,
        pageSize: -1
      };
      getGovService(reqParam).then(
        res => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.GovList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    },
    //getUserOneLevelRole
    getUserOneLevelRole() {
      let reqParam = {
        pageIndex: 1,
        pageSize: -1
      };
      getEditRolesByUserCodeService(reqParam).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            // this.total = res.total;
            this.roleList = res.data;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.postSetting {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.el-footer {
  text-align: right;
}
/deep/.el-dialog {
  .el-select {
    width: 100%;
  }
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>
